import routes from 'const/routes'
import getMFEConfig from 'helpers/getMFEConfig'
import { useAtomValue, useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { PdfStatement } from 'statements-mfe'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

const PdfStatementPage = () => {
  const mfeConfig = getMFEConfig('mfe')
  const updateModalStatus = useSetAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const navigate = useNavigate()
  const statementsButtonId = `statements-button-${selectedAccount}`

  return (
    <PdfStatement
      config={mfeConfig}
      selectedAccountId={selectedAccount}
      onReturnToStatementListClick={(e) => {
        e.preventDefault()
        navigate(routes.HOME)
        if (selectedAccount) {
          updateModalStatus('Statement', statementsButtonId)
        }
      }}
    />
  )
}

export default PdfStatementPage
